// extracted by mini-css-extract-plugin
export var borderRadius = "_5e-4";
export var large = "_5e-3";
export var logoContainer = "_5e-0";
export var nameLogo = "_5e-2";
export var small = "_5e-1";